import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVerticalAlignmentLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="vertical-alignment-left"><path d="M3.75 3.75V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M20.25 6.75H6.75V10.25H20.25V6.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M16.25 13.75H6.75V17.25H16.25V13.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconVerticalAlignmentLeft;
